import { IFilterStateAction } from '../actions/filter-actions';
import { ActionType, ActionTypes } from '../../actions/index';
import { IFetchStateAction } from '../actions/filter-fetch';
import {ISeatMatchRequestModel} from '../../classes/request-model';
import * as redux from 'redux';
import { } from 'lodash';

export interface IPromoCodeModel {
    applying: boolean;
    promoCode: string;
    promoCodeDescription: string;
    promoCodeId: number;
    promoErrorMessage: string;
    promoConflict: boolean;
}

let defaultPromoCodeModel = {
    promoCode: "",
    promoCodeDescription: "",
    applying: false,
    promoCodeId: 0,
    promoErrorMessage: "",
    promoConflict: false
};

export { defaultPromoCodeModel};
export function promoCodeModel(state: IPromoCodeModel = defaultPromoCodeModel , action: IFetchStateAction) {
    switch (action.type) {
        case ActionTypes.APPLY_PROMO:
            return { ...state, promoCode: action.value, applying: true };
        case ActionTypes.REMOVE_PROMO:
            return { ...state, promoCode: "", applying: true };
        case ActionTypes.LOAD_PROMO:
            return {
                ...state,
                applying: false,
                promoCode: action.value.sourceName,
                promoCodeId: action.value.sourceCode,
                promoConflict: false
            };
        case ActionTypes.PROMO_ERROR:
            return { ...state, promoErrorMessage: action.value, applying: false };
        case ActionTypes.PROMO_CONFLICT:
            return { ...state, promoErrorMessage: action.value, promoConflict: true, applying: false };
        case ActionTypes.CANCEL_PROMO:
            return { ...state, promoErrorMessage: '', promoConflict: false, applying: false, promoCode: '' };
        case ActionTypes.EMPTIED_CART:
            return { ...state, promoErrorMessage: '', promoConflict: false, applying: false };
        default:
            return state;
    }
};
